import React from 'react';
import './NanoCeramicPage.css';

const NanoCeramicPage = () => {
  return (
    <div className="nano-ceramic-main">
      <section className="nano-ceramic-hero">
        <div className="nano-ceramic-hero-content">
          <h1>Nano Ceramic Film</h1>
        </div>
      </section>

      <section className="nano-ceramic-main-content">
        <h2>Nano Ceramic Window Films</h2>
        <h3>Advanced Heat Rejection. Superior Clarity. Ultimate Comfort.</h3>
        <p>Derma Protec's Nano Ceramic Series sets the gold standard for high-performance automotive window films. Built using cutting-edge nanotechnology and aerospace-grade materials, these films don't just tint your vehicle—they transform the way you drive.</p>
        <p>Unlike dyed or metalized films, nano ceramic films incorporate microscopic ceramic particles—free of metal and dyes—to offer unrivaled solar heat rejection, crystal-clear visibility, and long-term durability without signal interference.</p>
        <hr />
        <h3>🌡️ Technology That Works for You</h3>
        <ul>
          <li>Originally developed for space shuttle applications, nano ceramic technology is designed to endure extreme temperatures and solar radiation. This same innovation is now available for your vehicle:</li>
          <li>Blocks up to 100% of harmful UV rays</li>
          <li>Rejects up to 100% of infrared (IR) radiation, the main source of heat</li>
          <li>Reduces cabin heat buildup by up to 70%, enhancing comfort and reducing air conditioning usage</li>
          <li>Non-metallic composition means zero interference with GPS, mobile, and radio signals</li>
        </ul>
        <hr />
        <h3>🔬 Derma Protec Ceramic Plus: The Science Behind the Film</h3>
        <ul>
          <li>Blended Nanoparticles: A hybrid of Cesium and Tungsten Oxide offers extreme heat rejection with minimal light distortion.</li>
          <li>Ultra-Fine Milling: Ceramic particles are refined down to just 10 nanometers, eliminating haze and glare while maximizing visibility.</li>
          <li>Premium Japanese PET: We exclusively source PET substrates from top-tier manufacturers like Toray® Japan, known for unmatched film clarity and longevity.</li>
        </ul>
        <h3>🚘 Benefits at a Glance</h3>
        <ul>
          <li>Enhanced Driver & Passenger Comfort</li>
          <li>Reduced Interior Fading & Skin Damage</li>
          <li>Signal-Friendly Ceramic Technology</li>
          <li>Non-Reflective, Sleek Aesthetic</li>
          <li>Available in Legal VLT Options for front, rear, and side windows</li>
          <li>Fade-Resistant & Weather-Tough</li>
        </ul>
        <hr />
        <h3>🔒 Drive Smarter. Ride Cooler.</h3>
        <p>Whether you're commuting under the desert sun or parked for hours, Derma Protec's Nano Ceramic Films keep your vehicle cooler, your interiors protected, and your driving experience elevated.</p>
        <p>👉 Contact us today for a consultation or visit our showroom to explore samples and live demonstrations.</p>
        <div className="specs-table-wrapper">
          <table className="specs-table">
            <thead>
              <tr>
                <th>Model</th>
                <th>VLT</th>
                <th>IRR</th>
                <th>UVR</th>
                <th>O.D</th>
                <th>TSER</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>DPNC-05</td><td>5%</td><td>100%</td><td>100%</td><td>0.49</td><td>88%</td></tr>
              <tr><td>DPNC-10</td><td>10%</td><td>100%</td><td>100%</td><td>0.53</td><td>85%</td></tr>
              <tr><td>DPNC-20</td><td>20%</td><td>100%</td><td>100%</td><td>0.55</td><td>78%</td></tr>
              <tr><td>DPNC-30</td><td>30%</td><td>100%</td><td>100%</td><td>0.58</td><td>76%</td></tr>
              <tr><td>DPNC-40</td><td>40%</td><td>100%</td><td>100%</td><td>0.51</td><td>75%</td></tr>
              <tr><td>DPNC-50</td><td>50%</td><td>100%</td><td>100%</td><td>0.29</td><td>70%</td></tr>
              <tr><td>DPNC-65</td><td>65%</td><td>100%</td><td>100%</td><td>0.22</td><td>60%</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      <div className="cta-section">
        <h2>Experience the Difference</h2>
        <p>
          Transform your space with our premium Nano Ceramic Film. Contact us today to 
          learn more about how our advanced protection technology can benefit your home 
          or business.
        </p>
        <div className="cta-buttons">
          <a href="/find-dealer" className="cta-button primary">Find a Dealer Centre</a>
          <a href="/contact" className="cta-button secondary">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default NanoCeramicPage; 